import httpClient, { uploadClient } from "./axiosConfig";
import { buildURI, getQueryString } from "./../utils/buildURI";
import { AUTH_CLIENT_ID, AUTH_CLIENT_SECRET } from "./../constants";

export const OTP_ACTION_GENERATE = "generate";
export const OTP_ACTION_VERIFY = "verify";
export const SEGMENT = "sme";

export const config = {
  load: (product, segment = SEGMENT, headers = undefined) => {
    const query = getQueryString(product, segment);

    return httpClient.preAuth.request({
      method: "GET",
      url: `bbg-accounts/api/v1/config${query}`,
      ...headers
    });
  }
};

export const dataList = {
  get: segment =>
    httpClient.preAuth.request({
      url: `api/v1/datalist?segment=${segment}`,
      method: "GET"
    })
};

export const authentication = {
  login: (data, headers) =>
    httpClient.preAuth.request({
      url: buildURI("authenticateUserUri"),
      method: "POST",
      data,
      ...headers
    })
};

export const otp = {
  generate: (payload, headers) =>
    httpClient.preAuth.request({
      url: buildURI("otpUri"),
      method: "POST",
      ...headers,
      data: {
        ...payload
      }
    }),
  verify: (payload, headers) =>
    httpClient.preAuth.request({
      url: buildURI("otpUri"),
      method: "POST",
      ...headers,
      data: {
        action: OTP_ACTION_VERIFY,
        ...payload
      }
    })
};

export const prospect = {
  create: (data, headers) =>
    httpClient.preAuth.request({
      url: buildURI("createProspectUri"),
      method: "POST",
      ...headers,
      data
    }),
  update: (prospectId, data, headers) =>
    httpClient.postAuth.request({
      url: buildURI("updateProspectUri", prospectId),
      method: "PUT",
      ...headers,
      data
    }),
  get: (prospectId, headers) =>
    httpClient.postAuth.request({
      url: buildURI("getProspectUri", prospectId),
      method: "GET",
      ...headers
    })
};

export const getProspectDocuments = {
  retriveDocuments: (prospectId, headers) =>
    httpClient.postAuth.request({
      url: buildURI("getProspectDocumentsUri", prospectId),
      method: "GET",
      ...headers
    })
};

export const search = {
  searchApplication: (data, headers) =>
    httpClient.preAuth.request({
      url: buildURI("searchProspectUri"),
      method: "POST",
      ...headers,
      data
    })
};

export const screening = {
  send: prospectId =>
    httpClient.postAuth.request({
      url: buildURI("screenProspectUri", prospectId),
      method: "GET"
    })
};

export const uploadProspectDocument = {
  requestClientToken: headers =>
    httpClient.postAuth.request({
      url: buildURI("documentUploaderToken"),
      method: "POST",
      data: {
        client_id: AUTH_CLIENT_ID,
        client_secret: AUTH_CLIENT_SECRET,
        module_id: "DAO"
      },
      headers: { ...headers?.headers, "Content-Type": "application/x-www-form-urlencoded" }
    }),
  send: ({ data, prospectId, source, onUploadProgress, headers }) => {
    return uploadClient.request({
      url: buildURI("docUploaderUri", prospectId),
      method: "POST",
      headers: { ...headers?.headers, Accept: "application/json" },
      data
    });
  }
};

export const downloadProspectDocument = {
  get: (prospectId, documentKey, headers) =>
    uploadClient.request({
      url: buildURI("getDocumentByIdUri", prospectId, documentKey),
      method: "GET",
      responseType: "blob",
      ...headers
    })
};

// ro-assist-brd3-1
export const createInvite = {
  send: (data, headers) =>
    httpClient.postAuth.request({
      url: buildURI("createInviteUri"),
      method: "POST",
      ...headers,
      data
    })
};
export const postAuthToken = {
  get: (payload, headers) =>
    httpClient.postAuth.request({
      url: buildURI("postAuthToken"),
      method: "POST",
      data: payload,
      headers: {
        ...headers,
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: ""
      }
    })
};
